import './global-search.scss';
import { TextField } from '@nike/eds'
import { Search } from '@nike/nike-design-system-icons'
type GlobalSearchProps = {
  globalSearch: string
  handleGlobalSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  inputRef?: React.Ref<HTMLInputElement>
}


export function GlobalSearch({ globalSearch, handleGlobalSearchChange, inputRef }: GlobalSearchProps) {
  return (
    <div className='global-search'>
      <TextField
        id='global-search'
        className='global-search-input'
        type='search'
        label=''
        placeholder='Search...'
        beforeSlot={<Search />}
        value={globalSearch || ''}
        onChange={handleGlobalSearchChange}
        hideLabel
        autoComplete='off'
        ref={inputRef}
    />
  </div>
  )
}
